module.exports = __webpack_public_path__ + "static/promo5-880d2b5bf63f11f14cfc4ced8579a6e9.png";